import { useScreenSize } from '../../../hooks/useScreenSize';
import snow from '../../../assets/svg/snow.svg';
import sun from '../../../assets/svg/sun.svg';
import split from '../../../assets/img/split-unit.png';

import { Clock, Eye } from 'lucide-react';

const Header: React.FC = () => {
  const { isTablet } = useScreenSize();

  return (
    <section className={`header-container  flex-colomn gap-2  ${isTablet ? 'pt-10 mb-5' : 'pt-5'}`}>
      <div
        className={` ${isTablet ? 'flex-colomn gap-2 slide' : 'flex-row slide-full'} space-between align-center gap-5`}
      >
        <div className="flex-colomn w-100">
          <div className="flex-row space-between">
            <a href="/installatie-voorbeelden">
              <div className="flex-row align-center">
                <Eye size={isTablet ? 14 : 24} />
                <span>Ga Terug</span>
              </div>
            </a>
            <p className="flex-row align-center gap-sm">
              <Clock size={isTablet ? 10 : 16} />
              <span className="bold">2 min</span>
            </p>
          </div>
          <h1>
            <span className="tertiary-color">Split </span>unit!
          </h1>
          <div className={`${isTablet ? 'flex-colomn' : 'flex-colomn gap-2'}`}>
            <p>
              Bekijk de details en ontdek of ze aansluiten bij uw project.
              <span className="bold"> Past dit bij uw wensen?</span> Vraag dan{' '}
              <span className="bold">eenvoudig</span> een <span className="bold">offerte</span> aan.
            </p>
            <div className="flex-colomn gap-2 pt-1">
              <div className="flex-row-align gap-2 ">
                <img className="icon-small" src={snow} alt="phone icon" />
                <p className="light">Koelt tot 18°</p>
              </div>
              <div className="flex-row-align gap-2">
                <img className="icon-small" src={sun} alt="phone icon" />
                <p className="light">Verwarmt tot 30°</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-row justify-center w-100">
          <img className="product-img" src={split} alt="Split unit airconditioning installatie" />
        </div>
      </div>
    </section>
  );
};

export default Header;
